import React from 'react';
import OtaPage from './index';

// 固件管理 = 完整 OTA 页面（默认停在“固件管理”tab，升级任务也在）
const FirmwarePage: React.FC = () => <OtaPage />;

export default FirmwarePage;
